import { render } from "./AboutUsPs.vue?vue&type=template&id=a6c9ea66&scoped=true"
import script from "./AboutUsPs.vue?vue&type=script&lang=js"
export * from "./AboutUsPs.vue?vue&type=script&lang=js"

import "./AboutUsPs.vue?vue&type=style&index=0&id=a6c9ea66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c9ea66"]])

export default __exports__